export enum ButtonType {
    PRIMARY = 'primary',
    PRIMARY_DARK = 'primaryDark',
    SECONDARY = 'secondary',
    SECONDARY_DARK = 'secondaryDark',
    TERTIARY = 'tertiary',
    TERTIARY_DARK = 'tertiaryDark'
}
